var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinearInfoModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 65C5.5 31.8629 32.3629 5 65.5 5C98.6371 5 125.5 31.8629 125.5 65C125.5 98.1371 98.6371 125 65.5 125C32.3629 125 5.5 98.1371 5.5 65Z",
    fill: "#DDF0DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 65C5.5 31.8629 32.3629 5 65.5 5C98.6371 5 125.5 31.8629 125.5 65C125.5 98.1371 98.6371 125 65.5 125C32.3629 125 5.5 98.1371 5.5 65Z",
    stroke: "#EEF7ED",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0002 75.6663V64.9997M66.0002 54.333H66.0268M92.6668 64.9997C92.6668 79.7273 80.7278 91.6663 66.0002 91.6663C51.2726 91.6663 39.3335 79.7273 39.3335 64.9997C39.3335 50.2721 51.2726 38.333 66.0002 38.333C80.7278 38.333 92.6668 50.2721 92.6668 64.9997Z",
    stroke: "#3C7B35",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearInfoModal);
export default __webpack_public_path__ + "static/media/linear_infoModal.18d489279357c52447713c586d623f0a.svg";
export { ForwardRef as ReactComponent };